import React from 'react';
import { Button } from '../components/ui/button';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="bg-white py-16 md:py-20">
        <div className="container mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: '#D4AF37' }}>
            About
          </h1>
          <p className="text-center text-gray-600 max-w-3xl mx-auto">
            Why I'm different from every other social media agency targeting medical specialists.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-6 text-gray-600 leading-relaxed">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              Most private obstetricians are exceptional at what they do.
            </h2>
            
            <p>
              But keeping up with social media, staying visible online, and making sure referred patients actually feel confident enough to book?
            </p>
            
            <p className="font-medium text-gray-700">
              That's a whole other job.
            </p>
            
            <p>
              One you didn't train for. One you don't have time for. And honestly, one you shouldn't be doing yourself.
            </p>
            
            <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4">
              That's where I come in.
            </h3>
            
            <p>
              I help private obstetricians and gynaecologists show up consistently online without it eating into the time you need for patients, theatre, and actually having a life.
            </p>

            <div className="bg-[#FFF9E6] border-l-4 border-[#F0C419] p-6 my-8">
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                Here's what makes me different from every other agency that's probably already slid into your LinkedIn DMs.
              </h3>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">
                  I'm a Registered Nurse with 16 years of clinical experience.
                </h4>
                <p>
                  I've worked with private specialists for 11 years. I understand your world, your patients, and your compliance obligations under AHPRA. I'm not learning on your time—I already know the rules.
                </p>
              </div>

              <div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">
                  Using AI tools combined with 11 years of social media experience...
                </h4>
                <p>
                  I create content that sounds like you, builds trust with referred patients before they ever call your rooms, and stays 100% AHPRA compliant.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg my-8">
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-[#F0C419] font-bold mr-3 text-xl">✗</span>
                  <span className="font-medium">No cookie-cutter templates.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#F0C419] font-bold mr-3 text-xl">✗</span>
                  <span className="font-medium">No generic medical stock photos.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#F0C419] font-bold mr-3 text-xl">✗</span>
                  <span className="font-medium">No content that makes you look like every other clinic on Instagram.</span>
                </li>
              </ul>
            </div>

            <p className="text-lg font-medium text-gray-800">
              Just consistent, professional content that converts GP referrals and Google searches into booked patients while you focus on your craft.
            </p>

            <div className="bg-[#F0C419] p-8 rounded-lg my-8 text-center">
              <p className="text-xl font-bold text-black mb-4">
                If your online presence doesn't reflect the quality of care you actually deliver, let's fix that.
              </p>
            </div>

            <div className="text-center pt-6">
              <p className="mb-6">
                In 20 minutes I'll take a look at your current online presence, tell you exactly what's working and what's losing you referred patients, and give you one thing you could change today.
              </p>
              <p className="mb-8 font-medium">
                If we're a good fit, I'll tell you. If we're not, I'll tell you that too.
              </p>
              <a href="https://calendly.com/ainsleygreenslade/onlinepresenceaudit" target="_blank" rel="noopener noreferrer">
                <Button className="bg-[#F0C419] hover:bg-[#D4AF37] text-black font-medium px-8 py-3 rounded transition-colors duration-200 text-lg">
                  Book Your Free 20-Minute Audit
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;